<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Screen from "../../../components/screen";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import Loading from "@/components/c-loading";
import Row from "../../../components/recieved-stock-owner-row.vue";
import { stockjournalService } from "../../../services/financeservice/stockjournal.service";
import { stockjournalentryService } from "../../../services/financeservice/stockjournalentry.service";
import { servicehelpers } from "../../../services/servicehelpers";
import i18n from "../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Journal Form",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading,
    Button,
    Input,
    Row
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      stockOwnerJournal: {},
      stockOwnerSummaryDataList: {},
      projectDataList: {},
      accounttDataList: {},
      stockJournalEntryData: {},
      valueProject: 0,
      valueDate: this.$moment().clone().format('YYYY-MM-DD'),
      valueInvestment: 0,
      valueNotation: '',
      valueEntries: [],
      valueType: 1,
      valueName: '',
      valueCode: '',
      valueAccount: 0,
      valueImage: '',
      valueNotations: [],
      
    };
  },
  mounted() {
    this.loadingAccountData();
    this.loadingByJournal(this.$route.params.id)

    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    if(hasId) {
      this.loadingData(this.$route.params.id);     

    } 
  },

  methods: {
    loadingData: function(id) {
      this.fetchingStats = false;
      stockjournalService.getOne(id)
        .then(response => {
            this.breadCrumb = {
              text: response.data.name + " - (" + response.data.code + ")",
              active: true,
            };

          this.fetchingStats = true;
          this.stockOwnerJournal = response;

          if(this.stockOwnerJournal.data.stock_owner_journal_status_id != 1) {
            this.$swal.fire({
              title: i18n.t('stock-owner.invalid-edit.title'),
              text: i18n.t('stock-owner.invalid-edit.message'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });

            this.$router.push(this.$route.query.redirectFrom || {
              name: "stock-owner-list"
            });
          }

          // console.log(JSON.stringify(this.stockOwnerJournal));

          this.valueProject = this.stockOwnerJournal.data.project_id;
          this.valueDate = this.stockOwnerJournal.data.invest_date;
          this.valueInvestment = this.stockOwnerJournal.data.invest_amount;
          this.valueNotation = this.stockOwnerJournal.data.notation;
          this.valueType = this.stockOwnerJournal.data.type_id == 1 ? 0 : 1;
          this.valueCode = this.stockOwnerJournal.data.code;
          this.valueName = this.stockOwnerJournal.data.name;
          this.valueAccount = this.stockOwnerJournal.account_id;

          this.stockOwnerJournal.data.collections.map(item => {
            if('stock_owner_journal_entries' in item) {
              this.valueEntries = item.stock_owner_journal_entries;
            }
          });

          // console.log(JSON.stringify(this.stockOwnerJournal.data));
          // console.log(this.valueType);
          
        });
    },

    loadingAccountData: function(type = 12) {
      servicehelpers.getAccountData(type).then(response => {
        this.accounttDataList = response;

        // console.log(JSON.stringify(this.accounttDataList.data));
      });
    },

    loadingByJournal: function(id) {
      
      stockjournalentryService.getListByJournal(id)
        .then(response => {       
          this.stockJournalEntryData = response.data;

          console.log(JSON.stringify(this.stockJournalEntryData));
        });
    },
    

    submitCancel: function() {

      // console.log(this.dataType);

      this.$swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "stock-owner-list"
          });

        }
      });
      
    },
    submitSave: function() {

      this.tryingToSubmit = true;
      let entries = [];
      this.stockJournalEntryData.map((item, index) => {

        let paid = (this.$refs[`payment-term-${index}`][0]).getPayValue();

        if(paid > 0) {
          entries.push({
            id: item.id,
            paid
          });
        }
      });

      // console.log(JSON.stringify(entries));
  

      stockjournalentryService.savePayment(entries)
        .then(response => {
        this.tryingToSubmit = false;

        if(response.status == 200) {
          this.clearForm();
          this.$swal.fire({
            title: i18n.t('general.success.title'),
            text: i18n.t('general.success.message'),
            icon: "success",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            confirmButtonText: i18n.t('general.success.yes'),
            cancelButtonText: i18n.t('general.success.no')
          }).then(result => {
            if (!result.value) {
              this.$router.push(this.$route.query.redirectFrom || {
                name: "stock-owner-list"
              });
            } 
          });
        }
      });
      
    },

    clearForm: function() {
      this.valueProject = 0;
      this.valueDate = this.$moment().clone().format('YYYY-MM-DD'),
      this.valueInvestment = 0;
      this.valueNotation = '';
      this.valueType = 1;
      this.valueName = '';
      this.valueCode = '';
      this.valueAccount = 0;
      
    }, 

    uploadPhotoSuccess(file, response) {
        // console.log("FFFFF", file);
        this.valueImage = [response.data];

        // console.log("#####", this.dataPhoto);
    },

    formatCurrency(value) {
      if(value == 0 ){
        return '';
      }
      let sign = '$';
      let decimal = ''; //'.00';
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

      // return value;

    },

  }
};
</script>

<template>
  <Layout>

      <PageHeader :items="[{
        text: $t('stock-owner.journal'),
        href: '/finance/stock',
      }, {
        text: $t('stock-owner.more.received-payment'),
        active: true
      }]" :title="$t('stock-owner.more.received-payment')" />

   

    <Loading :loaded="fetchingStats" />
    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
              
              <div class="row">
                <div class="col-lg-3">
                  <Input 
                    :type="'text'"
                    :id="'code'"
                    :disabled="true"
                    v-model="valueCode"
                    :label="'stock-owner.code'"  />
                </div>
                <div class="col-lg-4">
                  <Input 
                    :type="'text'"
                    :id="'name'"
                    :disabled="true"
                    v-model="valueName"
                    :label="'stock-owner.name'"  />
                </div>
                <div class="col-md-3">
                  <Input 
                    :type="'number'"
                    :id="'invest_amount'"
                    :disabled="true"
                    v-model="valueInvestment"
                    :last="'USD'"
                    :label="'stock-owner.investment'"  />
                </div>
                <div class="col-md-2">
                  <div class="form-check form-switch form-switch-md mb-3" style="margin-top: 33px;">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="type_id"
                      :disabled="true"
                      v-model="valueType"
                    />
                    <label class="form-check-label" for="type_id"
                      >{{$t('stock-owner.withdrawal')}}</label
                    >
                  </div>
                </div>
              </div>
          
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <div class="row" style="border-bottom: 1px solid #F6F6FF;" v-for="(item, index) in stockJournalEntryData" :key="index">
              <Row 
                :ref="`payment-term-${index}`"
                :index="index" 
                :item="item" />
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12">

                <div inline class="row gy-2 gx-3 align-items-end">
                  <div class="col-sm-auto">
                    <Button v-bind:icon="'bx bx-x-circle'" 
                      v-bind:buttonType="'button'"
                      v-bind:variant="'danger'"
                      @click="submitCancel()"
                      v-bind:title="$t('general.cancel')"  />
                  </div>
                  <div class="col-sm-auto">
                    <Button v-bind:icon="'bx bx-save bx-tada'" 
                      v-bind:buttonType="'button'"
                      @click="submitSave()"
                      v-bind:requesting="tryingToSubmit"
                      v-bind:title="$t('general.save')"  />
                  </div>
                </div>
  
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form> 
  
  </Layout>
</template>